import { addStyles } from 'ethcss'
import { grid, item, text } from 'theme'

const catalogTemplateRolesStyles = {
    catalogTemplateRoleIcon: {
        ...grid.flex,
        ...grid.normalCenter,
        ...item.pointer,
    },
    catalogTemplateRoleLabelWrapper: {
        ...grid.row,
        ...grid.noWrap,
        ...grid.normalCenter,
    },
    catalogTemplateRoleLabelChar: {
        ...grid.mr_mdPlus,
        ...grid.ml_md,
        ...text.darkCloud,
        ...text.up,
        ...text.md,
    },
    roleAddText: {
        textDecoration: 'underline',
    },
    rolesPanel: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        textDecoration: 'underline',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
}

addStyles(catalogTemplateRolesStyles)
export default catalogTemplateRolesStyles
